var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "listing-layout flex-column hp-10 ov-reset" },
    [
      _c("preloader", {
        staticClass: "preloader prelative",
        attrs: { display: _vm.loading }
      }),
      _vm._v(" "),
      _c("header", { staticClass: "flex-level mb-4" }, [
        _vm.$slots["header"] != ""
          ? _c("h1", { staticClass: "m-0" }, [_vm._t("header")], 2)
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "flex-right" }, [
          _c(
            "ul",
            { staticClass: "action-nav" },
            [
              _vm._l(_vm.primaryButtons, function(button) {
                return _c(
                  "li",
                  { key: button.label },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: _vm.$t.__(
                            "common.labels.no_necessary_rights"
                          ),
                          placement: "top",
                          disabled: !button.disabled
                        }
                      },
                      [
                        button.event != undefined
                          ? _c(
                              "a",
                              {
                                class: {
                                  "btn btn-primary btn-disabled":
                                    button.disabled
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.$emit(button.event)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(button.label) +
                                    "\n                        "
                                )
                              ]
                            )
                          : _c(
                              "a",
                              {
                                class: {
                                  "btn btn-primary btn-disabled":
                                    button.disabled
                                },
                                attrs: { href: button.href }
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(button.label) +
                                    "\n                        "
                                )
                              ]
                            )
                      ]
                    )
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c("CompassButton", {
                    attrs: {
                      label: _vm.$t.__("accounting.AgedBalance.CSV_export"),
                      disabled: !_vm.permissions.export
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.filexport("csv")
                      }
                    }
                  })
                ],
                1
              )
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "listing prelative flex-column ov-reset mh-0 flex" },
        [
          _c(
            "div",
            { staticClass: "kpis" },
            [
              _c("KpiList", {
                attrs: {
                  kpis: _vm.kpis,
                  type: "listing",
                  source: "agedbalance"
                }
              }),
              _vm._v(" "),
              _vm.kpis.length
                ? _c("CompassPlainButton", {
                    attrs: {
                      label: _vm.$t.__(
                        "accounting.AgedBalance.regenerate_statistics"
                      ),
                      leftIcon: "reload",
                      size: "small",
                      variant: "neutral"
                    },
                    on: { click: _vm.regen }
                  })
                : _c("CompassPlainButton", {
                    attrs: {
                      label: _vm.$t.__(
                        "accounting.AgedBalance.reload_statistics"
                      ),
                      leftIcon: "reload",
                      size: "small",
                      variant: "neutral"
                    },
                    on: { click: _vm.reload }
                  })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "listing-tools flex-level flex-top no-shrink mb-2 flex-end"
            },
            [
              _c("paginator", {
                attrs: { pagination: _vm.pagination },
                on: { "pagination:update": _vm.goToPage }
              }),
              _vm._v(" "),
              _c(
                "el-dropdown",
                { attrs: { placement: "bottom-end" } },
                [
                  _c("CompassIconButton", {
                    attrs: {
                      icon: "settings-fill",
                      variant: "default",
                      size: "small",
                      disabled: false
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c("el-dropdown-item", [
                        _c(
                          "a",
                          {
                            attrs: { href: "javascript:;" },
                            on: {
                              click: function($event) {
                                return _vm.$store.commit(
                                  _vm.listinghash + "/toggleDisplay",
                                  "table"
                                )
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$l10n.__("Gestion des lignes")))]
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex-row mh-0 flex" },
            [
              _c(
                "transition",
                { attrs: { name: "slide-fade" } },
                [
                  _vm.display.table
                    ? _c("listing-display", {
                        attrs: { listinghash: _vm.listinghash }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "listingContainer br flex flex-column" },
                [
                  !_vm.error &&
                  !_vm.loading &&
                  Object.keys(_vm.rows).length == 0
                    ? _c(
                        "div",
                        { staticClass: "placeholder" },
                        [
                          _c("p", { staticClass: "acenter" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$l10n.__(
                                    "Aucun résultat ne correspond aux filtres appliqués"
                                  )
                                ) +
                                "\n                    "
                            )
                          ]),
                          _vm._v(" "),
                          _c("CompassButton", {
                            attrs: { label: _vm.$t.__("common.actions.reset") },
                            on: {
                              click: function($event) {
                                return _vm.$store.dispatch(
                                  _vm.listinghash + "/resetListing"
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.error
                    ? _c(
                        "div",
                        { staticClass: "placeholder" },
                        [
                          _c("p", { staticClass: "acenter" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$l10n.__(
                                    "Une erreur est survenue, réinitialisez votre listing"
                                  )
                                ) +
                                "\n                    "
                            )
                          ]),
                          _vm._v(" "),
                          _c("CompassButton", {
                            attrs: { label: _vm.$t.__("common.actions.reset") },
                            on: {
                              click: function($event) {
                                return _vm.$store.dispatch(
                                  _vm.listinghash + "/resetListing"
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  Object.keys(_vm.rows).length > 0
                    ? _c("aged-balance-table", {
                        ref: "listingTable",
                        attrs: {
                          listinghash: _vm.listinghash,
                          rows: _vm.rows,
                          columns: _vm.activeColumns
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.display.export
            ? _c("export-modal", {
                attrs: {
                  listinghash: _vm.listinghash,
                  "all-column-option": false,
                  exportType: _vm.display.exportType
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }